/** Infinite horizontal ticker. Pauses on hover; static for reduced motion (CSS). */
export default function Marquee({ items, className = "" }) {
  const row = items.map((t, i) => (
    <span key={i} className="inline-flex items-center gap-3 px-5">
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-brand-gold" />
      {t}
    </span>
  ));
  return (
    <div className={`kj-marquee overflow-hidden ${className}`} role="list" aria-label={items.join(". ")}>
      <div className="kj-marquee-track inline-flex whitespace-nowrap" aria-hidden="true">
        {row}{row}
      </div>
    </div>
  );
}
